<template>
  <div>
    <build-nav v-if="showSideNavigation"></build-nav>
    <top-nav-bar></top-nav-bar>
    <v-container fluid>
      <v-row>
        <v-col>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

import BuildNav from "./Nav";
import TopNavBar from "@/components/TopNavBar";

export default {
  components: {
    BuildNav,
    TopNavBar,
  },
  computed: {
    showSideNavigation() {
      const hideNavigation = this.$route.meta.disableSideNavigation;
      return this.showSideNavigationStore && !hideNavigation;
    },
    ...mapState({
      showSideNavigationStore: state => state.application.showSideNavigation,
    }),
  },
};
</script>
